import { createContext } from 'react';

interface PictureContextProps {
  lazy?: boolean;
}

export const PictureContext = createContext<PictureContextProps>({ lazy: false });
